module.exports = __webpack_public_path__ + "static/privat24-081b16a0b1a16b5185f1370e7d56270e.png";